(function () {
  var root = document.querySelector(".moojo-av");
  if (!root) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var players = [];

  function tell(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage('{"event":"command","func":"' + func + '","args":""}', "*");
  }

  function hush(except) {
    players.forEach(function (player) {
      if (player === except || !player.on) return;
      player.on = false;
      tell(player.frame.querySelector("iframe"), "mute");
      player.btn.textContent = "Activer le son";
      player.btn.setAttribute("aria-pressed", "false");
    });
  }

  function mount(frame, withSound) {
    var existing = frame.querySelector("iframe");
    if (existing) return existing;
    var iframe = document.createElement("iframe");
    var id = frame.getAttribute("data-video");
    var autoplay = reduce ? "0" : "1";
    var sound = withSound ? "0" : "1";
    iframe.src = "https://www.youtube-nocookie.com/embed/" + id
      + "?autoplay=" + autoplay
      + "&mute=" + sound
      + "&controls=1&playsinline=1&rel=0&enablejsapi=1";
    iframe.title = frame.getAttribute("data-title") || "Film";
    iframe.allow = "autoplay; encrypted-media; picture-in-picture";
    iframe.allowFullscreen = true;
    var poster = frame.querySelector("img");
    if (poster) frame.replaceChild(iframe, poster);
    else frame.appendChild(iframe);
    return iframe;
  }

  root.querySelectorAll("[data-av-frame]").forEach(function (frame) {
    var btn = frame.parentElement.querySelector("[data-av-sound]");
    var player = { frame: frame, btn: btn, on: false, playing: false, away: false };
    players.push(player);
    if (btn) {
      btn.addEventListener("click", function () {
        var iframe = frame.querySelector("iframe");
        if (!iframe) {
          mount(frame, true);
          player.on = true;
          player.playing = true;
          hush(player);
        } else {
          player.on = !player.on;
          tell(iframe, player.on ? "unMute" : "mute");
          if (player.on) {
            tell(iframe, "playVideo");
            player.playing = true;
            player.away = false;
            hush(player);
          }
        }
        btn.textContent = player.on ? "Couper le son" : "Activer le son";
        btn.setAttribute("aria-pressed", player.on ? "true" : "false");
      });
    }
    if (reduce || !("IntersectionObserver" in window)) return;
    var watch = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var iframe = frame.querySelector("iframe");
        if (entry.isIntersecting) {
          if (!iframe) {
            mount(frame, false);
            player.playing = true;
            watch.disconnect();
          } else if (player.playing && player.away) {
            tell(iframe, "playVideo");
            player.away = false;
          }
          return;
        }
        if (!iframe || !player.playing) return;
        tell(iframe, "pauseVideo");
        player.away = true;
      });
    }, { threshold: 0.35 });
    watch.observe(frame);
  });
})();
